import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { withTheme } from '@material-ui/core/styles';
import { API_URL } from 'config.jsx';
import moment from 'moment';

export class ActivityMarkers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      measuringDates: null,
      logbookDates: null,
    };
  }

  async componentDidMount() {
    this.setState(await this.fetchActivity());
  }

  async fetchActivity() {
    const { elephantId } = this.props;
    try {
      const response = await axios.get(`${API_URL}elephants/${elephantId}/activity/`);
      return ({
        measuringDates: response.data.measuring_dates,
        logbookDates: response.data.logbook_dates,
      });
    } catch (err) {
      return ({ measuringDates: null, logbookDates: null });
    }
  }

  createMarker(type, date) {
    const {
      start, focusedDate, theme, yearWidth,
    } = this.props;
    const dateMoment = moment(date);
    const x = dateMoment.diff(start, 'days') / 365 * yearWidth;
    const focused = dateMoment.isSame(focusedDate);
    return (
      <div
        key={date + type}
        style={{
          transform: 'translate(-50%, 0)',
          width: '4px',
          height: '4px',
          borderRadius: '2px',
          backgroundColor: theme.lifeline.palette.markers[focused ? 'time' : type],
          zIndex: focused ? 301 : 300,
          position: 'absolute',
          left: `${x}px`,
          top: type === 'logbook' ? '6px' : '0px',
        }}
      />
    );
  }

  render() {
    const { measuringDates, logbookDates } = this.state;
    return (
      <div style={{ marginTop: '5px', height: '18px', position: 'relative' }}>
        {measuringDates !== null && measuringDates.map(date => this.createMarker('measure', date))}
        {logbookDates !== null && logbookDates.map(date => this.createMarker('logbook', date))}
      </div>
    );
  }
}

ActivityMarkers.propTypes = {
  yearWidth: PropTypes.number.isRequired,
  start: PropTypes.shape().isRequired,
  elephantId: PropTypes.number.isRequired,
  focusedDate: PropTypes.shape(),
  theme: PropTypes.shape().isRequired,
};

ActivityMarkers.defaultProps = {
  focusedDate: null,
};

export default withTheme()(ActivityMarkers);



// WEBPACK FOOTER //
// ./src/components/lifeline/Line/ActivityMarkers.jsx